import api from './api';
import type { BilltoOpt, BrokerOpt, CustomerOpt, LocationOpt } from './contstatusreport.service';

/**
 * Custom Chassis Charges — option bundle for the drawer + the SCAC-line subtable
 * (cms.customchassischarges_scac). The Bill To/Customer/Location lookups reuse the
 * same enriched shapes as Container Status Reports.
 */
export interface ScacOpt { scac: string; name: string; }

export interface CustomChassisChargesOptions {
  billtos: BilltoOpt[];
  brokers: BrokerOpt[];
  customers: CustomerOpt[];
  locations: LocationOpt[];
  regions: string[];
  scacs: ScacOpt[];
  chassispools: string[];
  daystypes: string[];
}

export interface ScacLine {
  recno: number; // 0 = new
  scac: string;
  chassispool: string;
  createaddlcost: string; // 'Y' | 'N'
  invoiced: string;       // 'Y' | 'N'
  numfreedays: string;
  daystype: string;       // '' | 'Business' | 'Calendar'
  expirationdate: string; // 'YYYY-MM-DD'
}

export async function getCustomChassisChargesOptions(): Promise<CustomChassisChargesOptions> {
  const res = await api.get('/customchassischarges/form-options');
  return res.data as CustomChassisChargesOptions;
}

export async function listScacLines(recno: number): Promise<ScacLine[]> {
  const res = await api.get(`/customchassischarges/${recno}/scac-lines`);
  return (res.data?.lines || []) as ScacLine[];
}

export async function saveScacLines(recno: number, lines: ScacLine[], deletes: number[]): Promise<void> {
  await api.put(`/customchassischarges/${recno}/scac-lines`, { lines, deletes });
}
